(function () {
  "use strict";

  var ATTRIBUTE_NAME = "ppk_ads_consent";
  var ATTRIBUTE_SOURCE = "ppk_ads_consent_source";
  var SOURCE_VALUE = "shopify_customer_privacy_api_v1";
  var VALID_STATES = ["accepted", "refused", "unknown"];
  var latestSync = 0;

  function normaliseConsent(value) {
    if (value === true || value === "yes" || value === "accepted" || value === "granted") {
      return "accepted";
    }
    if (value === false || value === "no" || value === "refused" || value === "denied") {
      return "refused";
    }
    return "unknown";
  }

  function stateFromObject(value) {
    if (!value || typeof value !== "object") {
      return "unknown";
    }

    var candidates = [
      value.marketing,
      value.marketingAllowed,
      value.marketing_allowed,
      value.detail && value.detail.marketing,
      value.detail && value.detail.marketingAllowed,
      value.detail && value.detail.marketing_allowed
    ];

    for (var index = 0; index < candidates.length; index += 1) {
      if (candidates[index] !== undefined && candidates[index] !== null && candidates[index] !== "") {
        return normaliseConsent(candidates[index]);
      }
    }
    return "unknown";
  }

  function readCurrentState() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) {
      return "unknown";
    }

    try {
      if (typeof privacy.currentVisitorConsent === "function") {
        var current = stateFromObject(privacy.currentVisitorConsent());
        if (current !== "unknown") {
          return current;
        }
      }

      if (typeof privacy.getTrackingConsent === "function") {
        var tracking = privacy.getTrackingConsent();
        var trackingState = typeof tracking === "object"
          ? stateFromObject(tracking)
          : normaliseConsent(tracking);
        if (trackingState !== "unknown") {
          return trackingState;
        }
      }

      if (typeof privacy.marketingAllowed === "function" && privacy.marketingAllowed()) {
        return "accepted";
      }

    } catch (error) {
      return "unknown";
    }

    return "unknown";
  }

  function cartUpdateUrl() {
    var root = window.routes && window.routes.rootUrl;
    if (!root || root === "/") {
      return "/cart/update.js";
    }
    return root.replace(/\/$/, "") + "/cart/update.js";
  }

  function cartJsonUrl() {
    var root = window.routes && window.routes.rootUrl;
    if (!root || root === "/") {
      return "/cart.js";
    }
    return root.replace(/\/$/, "") + "/cart.js";
  }

  function updateCart(normalised, syncNumber) {
    if (syncNumber !== latestSync) {
      return Promise.resolve(normalised);
    }
    var attributes = {};
    attributes[ATTRIBUTE_NAME] = normalised;
    attributes[ATTRIBUTE_SOURCE] = SOURCE_VALUE;

    return window.fetch(cartUpdateUrl(), {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Shopify cart consent update failed with status " + response.status);
      }
      return normalised;
    }).catch(function () {
      return normalised;
    });
  }

  function syncState(state, force) {
    var normalised = VALID_STATES.indexOf(state) === -1 ? "unknown" : state;
    latestSync += 1;
    var syncNumber = latestSync;
    if (force) {
      return updateCart(normalised, syncNumber);
    }

    return window.fetch(cartJsonUrl(), {
      method: "GET",
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Shopify cart read failed with status " + response.status);
      }
      return response.json();
    }).then(function (cart) {
      if (syncNumber !== latestSync) {
        return normalised;
      }
      var existing = cart && cart.attributes && cart.attributes[ATTRIBUTE_NAME];
      if (existing === normalised) {
        return normalised;
      }
      if (normalised === "unknown" && VALID_STATES.indexOf(existing) !== -1) {
        return existing;
      }
      return updateCart(normalised, syncNumber);
    }).catch(function () {
      return normalised;
    });
  }

  function onConsentCollected(event) {
    var eventState = stateFromObject(event);
    syncState(eventState === "unknown" ? readCurrentState() : eventState, true);
  }

  function start() {
    syncState(readCurrentState(), false);
    document.addEventListener("visitorConsentCollected", onConsentCollected);
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
    window.Shopify.loadFeatures([{
      name: "consent-tracking-api",
      version: "0.1",
      onLoad: start
    }]);
  } else {
    start();
  }
})();
